import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const isScheduleCodeInUse = api(async function isScheduleCodeInUse(code, excludeScheduleId, projectId) {
    return query(
        gql`
            query IsScheduleCodeInUse($code: String!, $excludeScheduleId: String, $projectId: String) {
                isScheduleCodeInUse(code: $code, excludeScheduleId: $excludeScheduleId, projectId: $projectId)
            }
        `,
        { code, excludeScheduleId, projectId },
        { returns: "isScheduleCodeInUse", fetchPolicy: "network-only" }
    )
})
